import React from 'react';
import { Linking } from 'react-native';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
import PropTypes from 'prop-types';
import IconButton from '../common/IconButton';

export const SupportedSocialPlatforms = Object.freeze({
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    TWITTER: 'twitter',
    XTWITTER: 'x-twitter',
    YOUTUBE: 'youtube'
});

const SocialLink = ({ iconColor, iconStyle, id, link, nodeTypeAlias, size = 24, style, type }) => {
    const renderSocialIcon = iconType => {
        const icon = <FontAwesome6 name={iconType} size={size} color={iconColor} style={{ paddingHorizontal: 4, ...iconStyle }} />;
        let dataSet = {};

        if (nodeTypeAlias) {
            dataSet.umbracoComponentName = nodeTypeAlias;
        }

        return <IconButton dataSet={dataSet} icon={icon} key={id} onPress={() => link && Linking.openURL(link)} style={style} />;
    };

    if (type.equals(SupportedSocialPlatforms.FACEBOOK)) {
        return renderSocialIcon('facebook');
    } else if (type.equals(SupportedSocialPlatforms.INSTAGRAM)) {
        return renderSocialIcon('instagram');
    } else if (type.equals(SupportedSocialPlatforms.TWITTER) || type.equals(SupportedSocialPlatforms.XTWITTER)) {
        return renderSocialIcon('x-twitter');
    } else if (type.equals(SupportedSocialPlatforms.YOUTUBE)) {
        return renderSocialIcon('youtube');
    }

    return null;
};

SocialLink.propTypes = {
    iconColor: PropTypes.string,
    iconStyle: PropTypes.object,
    link: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    style: PropTypes.object,
    type: PropTypes.string
};

export default SocialLink;
